import { VirtualPadRoles } from "@/interfaces/virtualPad_types"

/* --------- PADS SESSION ---------*/
export enum PadSessionStagesV1 {
  NONE,
  CONNECTED,
  CREATED,
  CLOSED
}

export enum VirtualPadMessageTypes {
  ERROR = 'error',
  PING = 'ping',
  PONG = 'pong',
  CREATE = 'create',
  CREATED = 'created',
  PEER_JOINED = 'peer-joined',
  PEER_LEFT = 'peer-left',
  OFFER = 'offer',
  ANSWER = 'answer',
  ICE_CANDIDATE = 'ice-candidate',
  CLOSE = 'close'
}

export enum VirtualPadErrorCodes {
  INVALID_MSG = 'invalid message',
  CONNECTION_NOT_IN_SESSION = 'connection not in session',
  SESSION_ALREADY_EXISTS = 'session already exists',
  SESSION_NOT_FOUND = 'session not found',
  PEER_NOT_FOUND = 'peer not found',
  INTERNAL_SERVER_ERROR = 'internal server error'
}

export interface VirtualPadCreateMsg {
  type: VirtualPadMessageTypes.CREATE
  role: VirtualPadRoles
}

export interface VirtualPadCreatedMsg {
  type: VirtualPadMessageTypes.CREATED
  sessionID: string
  connectionID: string
}

export interface VirtualPadPeerJoinedMsg {
  type: VirtualPadMessageTypes.PEER_JOINED
  sessionID: string
  connectionID: string
  role: VirtualPadRoles.PAD
}

export interface VirtualPadPeerLeftMsg {
  type: VirtualPadMessageTypes.PEER_LEFT
  sessionID: string
  connectionID: string
  role: VirtualPadRoles.PAD
}

export interface VirtualPadOfferMsg {
  type: VirtualPadMessageTypes.OFFER
  target: string
  sdp: string
}

export interface VirtualPadAnswerMsg {
  type: VirtualPadMessageTypes.ANSWER
  sessionID: string
  from: string
  sdp: string
}

export interface VirtualPadSendICECandidatesMsg {
  type: VirtualPadMessageTypes.ICE_CANDIDATE
  target: string
  candidate: RTCIceCandidateInit
}

export interface VirtualPadReceiveICECandidatesMsg {
  type: VirtualPadMessageTypes.ICE_CANDIDATE
  sessionID: string
  from: string,
  candidate: RTCIceCandidateInit
}

export interface VirtualPadCloseMsg {
  type: VirtualPadMessageTypes.CLOSE
}

export interface VirtualPadPingMsg {
  type: VirtualPadMessageTypes.PING
  sessionID: string
  connectionID: string
}

export interface VirtualPadPongMsg {
  type: VirtualPadMessageTypes.PONG
}

export interface VirtualPadErrorMsg<TCode extends VirtualPadErrorCodes = VirtualPadErrorCodes> {
  type: VirtualPadMessageTypes.ERROR
  error: TCode
}

export type VirtualPadCreateErrors =
  | VirtualPadErrorCodes.INVALID_MSG
  | VirtualPadErrorCodes.SESSION_ALREADY_EXISTS
  | VirtualPadErrorCodes.INTERNAL_SERVER_ERROR

export type VirtualPadOfferErrors =
  | VirtualPadErrorCodes.INVALID_MSG
  | VirtualPadErrorCodes.CONNECTION_NOT_IN_SESSION
  | VirtualPadErrorCodes.SESSION_NOT_FOUND
  | VirtualPadErrorCodes.PEER_NOT_FOUND
  | VirtualPadErrorCodes.INTERNAL_SERVER_ERROR

export type VirtualPadIceCandidateErrors =
  | VirtualPadErrorCodes.INVALID_MSG
  | VirtualPadErrorCodes.CONNECTION_NOT_IN_SESSION
  | VirtualPadErrorCodes.SESSION_NOT_FOUND
  | VirtualPadErrorCodes.PEER_NOT_FOUND
  | VirtualPadErrorCodes.INTERNAL_SERVER_ERROR

export type VirtualPadPingErrors =
  | VirtualPadErrorCodes.INVALID_MSG
  | VirtualPadErrorCodes.SESSION_NOT_FOUND
  | VirtualPadErrorCodes.INTERNAL_SERVER_ERROR

export type VirtualPadCloseErrors =
  | VirtualPadErrorCodes.INVALID_MSG
  | VirtualPadErrorCodes.CONNECTION_NOT_IN_SESSION
  | VirtualPadErrorCodes.SESSION_NOT_FOUND
  | VirtualPadErrorCodes.INTERNAL_SERVER_ERROR

export type VirtualPadSessionReqMessages =
  | VirtualPadCreateMsg
  | VirtualPadOfferMsg
  | VirtualPadSendICECandidatesMsg
  | VirtualPadPongMsg
  | VirtualPadCloseMsg

export type VirtualPadSessionResMessages =
  | VirtualPadCreatedMsg
  | VirtualPadPeerJoinedMsg
  | VirtualPadPeerLeftMsg
  | VirtualPadAnswerMsg
  | VirtualPadReceiveICECandidatesMsg
  | VirtualPadPingMsg
  | VirtualPadErrorMsg<VirtualPadCreateErrors | VirtualPadOfferErrors | VirtualPadPingErrors | VirtualPadIceCandidateErrors | VirtualPadCloseErrors>